import React, { useEffect, useMemo, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { useNavigate } from "react-router-dom";
import withRouter from "../../../components/Common/withRouter";
import { withTranslation } from "react-i18next";

import GlobalLoader from "../../../components/Common/GlobalLoader";
import TableContainerWarehouseRx from "../../../components/Common/TableContainerWarehouseRx";

import { getAdvancedSalary } from "../../../slice/thunks";

const GetAdvancedSalary = (props) => {
  const dispatch = useDispatch();
  const history = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [pageSize] = useState(10);

  const selectLayoutState = (state) => state.Settings;
  const OutputsProperties = createSelector(selectLayoutState, (outputs) => ({
    advancedSalaries: outputs.advancedSalary,
    error: outputs.error,
  }));

  const { advancedSalaries, error } = useSelector(OutputsProperties);

  const items = advancedSalaries?.items || [];
  const tableTotal = advancedSalaries?.total_items || items.length;
  const tableTotalPage = advancedSalaries?.total_page || 1;

  const loadAdvancedSalary = useCallback(
    (page = 1, term = "") => {
      setIsLoading(true);
      dispatch(
        getAdvancedSalary({ page, size: pageSize, term })
      )
        .then(() => setIsLoading(false))
        .catch(() => setIsLoading(false));
      setCurrentPage(page);
      setSearchTerm(term);
    },
    [dispatch, pageSize]
  );

  useEffect(() => {
    loadAdvancedSalary(currentPage, searchTerm);
  }, [loadAdvancedSalary, currentPage, searchTerm]);

  const columns = useMemo(
    () => [
      {
        header: props.t("employee_name"),
        accessorKey: "fullName",
        enableColumnFilter: false,
      },
      {
        header: props.t("requested_amount"),
        accessorKey: "askAmount",
        cell: (info) => Number(info.getValue()).toLocaleString(),
        enableColumnFilter: false,
      },
      {
        header: props.t("owned_amount"),
        accessorKey: "ownedAmount",
        cell: (info) => Number(info.getValue()).toLocaleString(),
        enableColumnFilter: false,
      },
      {
        header: props.t("request_date"),
        accessorKey: "requestDate",
        enableColumnFilter: false,
      },
      {
        header: props.t("Actions"),
        accessorKey: "actions",
        enableColumnFilter: false,
        cell: ({ row }) => (
          <div className="d-flex gap-2">
            {/* Historique */}
            <button
              onClick={() =>
                history(`/payroll/advanced-salary/${row.original.employeeId}/history`)
              }
              style={{ border: "none", background: "transparent", cursor: "pointer" }}
              title={props.t("view_history")}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#0d6efd" viewBox="0 0 24 24">
                <path d="M12 5c-7 0-11 7-11 7s4 7 11 7 11-7 11-7-4-7-11-7zm0 12a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm0-8a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"/>
              </svg>
            </button>

            {/* Nouvelle avance */}
            <button
              onClick={() => {
                const nameSlug = encodeURIComponent(row.original.fullName);
                history(`/payroll/advanced-salary/${row.original.employeeId}/assign/${nameSlug}`);
              }}
              style={{ border: "none", background: "transparent", cursor: "pointer" }}
              title={props.t("assign_new_advanced_salary")}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="green" viewBox="0 0 24 24">
                <path d="M19 11h-6V5h-2v6H5v2h6v6h2v-6h6z"/>
              </svg>
            </button>
          </div>
        ),
      },
    ],
    [props.t, history]
  );

  return (
    <div className="patients-list-content">
      <div className="patients-list px-2 pb-5">
        <div className="container-fluid">
          <div className="heading-parent-sec">
            <div className="heading-child-one-sec pt-4">
              <h6>{props.t("advanced_salary")}</h6>
            </div>
          </div>

          <div className="card border-0 row p-2">
            {isLoading ? (
              <GlobalLoader />
            ) : error ? (
              <div className="alert alert-danger mt-2">{String(error)}</div>
            ) : (
              <TableContainerWarehouseRx
                columns={columns}
                data={items}
                tablePage={currentPage}
                tableTotal={tableTotal}
                tableTotalPage={tableTotalPage}
                onNextPage={(page) => loadAdvancedSalary(page, searchTerm)}
                isGlobalFilter={true}
                onSearch={(term) => loadAdvancedSalary(1, term)}
                SearchPlaceholder={props.t("search_employee")}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(withTranslation()(GetAdvancedSalary));
